import { useState } from 'react';
import axios from 'axios';
import Footer from '../../component/footer';
import Header from '../../component/header';

export default function Home() {
  const [formdata, setFormdata] = useState({
    username: '',
    mobile: '',
    email: '',
    companyname: '',
  });
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const ApiUrl = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrorMsg('');
    setSuccessMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formdata.username || !formdata.mobile) {
      return setErrorMsg('Please enter all required fields');
    }

    try {
      setLoading(true);
      const response = await axios.post(`${ApiUrl}send`, formdata);
      console.log("Api response", response.data);
      setSuccessMsg(response.data.message);
      
      setFormdata({
        username: '',
        mobile: '',
        email: '',
        companyname: '',
      });

   // Clear success message after 3 seconds
    setTimeout(() => {
      setSuccessMsg('');
    }, 5000);

    } catch (err) {
      if (err.response && err.response.data) {
        setErrorMsg(err.response.data.message);
      } else {
        setErrorMsg('Something went wrong!');
      }
    // Clear error message after 3 seconds
    setTimeout(() => {
      setErrorMsg('');
    }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='mainhomepage'>
    <Header/>
    <div className='whatsapp-main'>
    <form onSubmit={handleSubmit} className="whatsappForm">
        {errorMsg && <p style={{ background: '#6c0000' }}>{errorMsg}</p>}
        {successMsg && <p style={{background: '#216021' }}>{successMsg}</p>}
        <h1>Send Whatsapp Message</h1>
      <div className="form-group">
        <input
          type="text"
          name="username"
          placeholder="Enter Name"
          value={formdata.username}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="mobile"
          placeholder="Enter Mobile Number"
          value={formdata.mobile}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="email"
          placeholder="Enter Email Address"
          value={formdata.email}
          onChange={handleChange}          
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="companyname"
          placeholder="Enter Company Name"
          value={formdata.companyname}
          onChange={handleChange}
        />
      </div>   

      <button type="submit" disabled={loading}>
        {loading ? 'Sending...' : 'Send'}
      </button>
    </form>
    </div>
    <Footer/>
    <img src='../images/bottommark.svg' alt='bottomimage' className='bottomimage'/>
    </div>
  );
}
